import { useState, useCallback } from 'react';
import { ToastMessageProps } from '@m/alchemy-ui/ToastMessage';

interface AutoDismissToastMessage extends ToastMessageProps {
  autoDismissDelay: number;
}

export type UserInputToastMessage = Omit<ToastMessageProps, 'key'>;

export function generateAutoDismissMessage(
  newMessage: ToastMessageProps
): AutoDismissToastMessage {
  return {
    key: Date.now(),
    ...newMessage,
    isDismissible: newMessage.isDismissible || false,
    shouldAutoDismiss: newMessage.shouldAutoDismiss || true,
    autoDismissDelay: newMessage.autoDismissDelay || 3000,
  };
}

export function useToasts() {
  const [messages, setMessages] = useState<Array<ToastMessageProps>>([]);

  const showMessage = useCallback((newMessage: UserInputToastMessage) => {
    setMessages([
      {
        key: Date.now(),
        ...newMessage,
      },
    ]);
  }, []);

  const clearMessages = useCallback(() => setMessages([]), []);

  return {
    messages,
    showMessage,
    clearMessages,
  };
}
